(function() {
  var ValidationEngine, ZonesAddDialog,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ZonesAddDialog = App.loadClass('portal::handlers/zones/AddEditDialog');

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.AddEditDialogWithIrr = (function(superClass) {
    extend(AddEditDialogWithIrr, superClass);

    function AddEditDialogWithIrr() {
      this.goToStep2 = bind(this.goToStep2, this);
      this.goToStep1 = bind(this.goToStep1, this);
      this._updateDist = bind(this._updateDist, this);
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      this.getPostData = bind(this.getPostData, this);
      this.init = bind(this.init, this);
      return AddEditDialogWithIrr.__super__.constructor.apply(this, arguments);
    }

    AddEditDialogWithIrr.prototype.init = function() {
      this.ppID = this.parent.ppID;
      this.layoutUrl = 'backend/portal/zones/zones/load-add-edit-dialog-with-irr';
      if (this.loadLayoutPostOptions == null) {
        this.loadLayoutPostOptions = {};
      }
      this.loadLayoutPostOptions.pp_id = this.ppID;
      this.saveUrl = 'backend/portal/zones/zones/save';
      this.classes = 'medium_dialog add_edit_zone_dialog';
      this.createDialog();
      this.openDialog();
      this.displayLoadingMessage('Loading Zone...');
      return this.validator = new ValidationEngine();
    };

    AddEditDialogWithIrr.prototype.getPostData = function() {
      var data;
      data = AddEditDialogWithIrr.__super__.getPostData.call(this);
      data.use_irrigation = $('#use_irrigation').is(':checked');
      return data;
    };

    AddEditDialogWithIrr.prototype.afterLoadLayout = function(selector, response) {
      var ref;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      AddEditDialogWithIrr.__super__.afterLoadLayout.call(this, selector, response);
      this.validator.makeFormValidator('step1', '#frm_edit_zones .step1', '#step1_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.goToStep2();
          } else {

          }
        };
      })(this));
      this.dialog.find('.counties-btn').on('click', (function(_this) {
        return function() {
          return _this.goToStep1();
        };
      })(this));
      this.dialog.find('.ranges-btn').on('click', (function(_this) {
        return function() {
          return _this.validator.validateForm('step1');
        };
      })(this));
      return this.goToStep1();
    };

    AddEditDialogWithIrr.prototype._updateDist = function() {
      return void 0;
    };

    AddEditDialogWithIrr.prototype.goToStep1 = function() {
      this.dialog.find('.step2').hide();
      this.dialog.find('.step1').show();
      this.dialog.find('.counties-btn').hide();
      this.dialog.find('.save-btn').hide();
      this.dialog.find('.cancel-btn').show();
      this.dialog.find('.ranges-btn').show();
      return this.setPosition();
    };

    AddEditDialogWithIrr.prototype.goToStep2 = function() {
      this.dialog.find('.step1').hide();
      this.dialog.find('.step2').show();
      this.dialog.find('.cancel-btn').hide();
      this.dialog.find('.ranges-btn').hide();
      this.dialog.find('.counties-btn').show();
      this.dialog.find('.save-btn').show();
      return this.setPosition();
    };

    return AddEditDialogWithIrr;

  })(ZonesAddDialog);

}).call(this);
